import { Link } from "react-router-dom";

import BannerSlider from "../common/BannerSlider";
import ProjectSlider from "../common/ProjectSlider";
import TestimonialSlider from "../common/TestimonialSlider";
import ClientSlider from "../common/ClientSlider";

const Home = () => {
    return (
        <>
            <BannerSlider />
            <section className="content-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-xl-4">
                            <div className="sub-heading mb-4"><em>Know more about!</em></div>
                            <div className="heading mb-4"><span className="weight-light"> A team with
                            </span> experience
                                and vision </div>
                            <div className="para-txt txt-large mb-5">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                            <Link to="/aboutus" className="button mb-5">Know More</Link>
                        </div>
                        <div className="col-lg-7 col-xl-7 offset-xl-1">
                            <div className="company-established">
                                <img src="./assets/images/image-1.jpg" width="100%" alt="" />
                                <div className="since">
                                    <div className="heading">2019</div>
                                    <div className="subheading">SINCE</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content-section lightbg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-xl-4">
                            <div className="sub-heading mb-4">Works</div>
                            <div className="heading mb-4"><span className="weight-light">Our Done</span> Projects</div>
                            <div className="para-txt mb-5 txt-large">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                            <Link to="/projects" className="button mb-5">View Our Work</Link>
                        </div>
                        <div className="col-lg-7 col-xl-7 offset-xl-1">
                            <ProjectSlider />
                        </div>
                    </div>
                </div>
            </section>
            <section className="content-section counter-section pos-rel" style={{ background: 'url(assets/images/banner.jpg) no-repeat', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="counter-block text-center">
                                <span className="icon"><i className="flaticon-skyline"></i></span>
                                <div className="heading">4+  <span>Years of Experience </span></div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="counter-block text-center">
                                <span className="icon"><i className="flaticon-skyline"></i></span>
                                <div className="heading">67+ <span>Projects Delivered </span></div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="counter-block text-center">
                                <span className="icon"><i className="flaticon-skyline"></i></span>
                                <div className="heading">50+ <span>People</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-xl-4">
                            <div className="sub-heading mb-4">What We Do?</div>
                            <div className="heading mb-4"><span className="weight-light">We Offer</span> Services</div>
                            <div className="para-txt mb-5 txt-large">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                        </div>
                        <div className="col-lg-7 col-xl-7 offset-xl-1">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="service-block">
                                        <span className="icon">
                                            <img src="./assets/images/icons/architect.png" alt="" />
                                        </span>
                                        <div className="service-meta">
                                            <h4 className="h4-style mb-2">Repairs & Strengthening</h4>
                                            <div className="para-txt">
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="service-block">
                                        <span className="icon">
                                            <img src="./assets/images/icons/brickwall.png" alt="" />
                                        </span>
                                        <div className="service-meta">
                                            <h4 className="h4-style mb-2">Retrofitting</h4>
                                            <div className="para-txt">
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="service-block">
                                        <span className="icon">
                                            <img src="./assets/images/icons/helmet.png" alt="" />
                                        </span>
                                        <div className="service-meta">
                                            <h4 className="h4-style mb-2">Specialized Coatings</h4>
                                            <div className="para-txt">
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="service-block">
                                        <span className="icon">
                                            <img src="./assets/images/icons/hook.png" alt="" />
                                        </span>
                                        <div className="service-meta">
                                            <h4 className="h4-style mb-2">Waterproofing</h4>
                                            <div className="para-txt">
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="service-block">
                                        <span className="icon">
                                            <img src="./assets/images/icons/house.png" alt="" />
                                        </span>
                                        <div className="service-meta">
                                            <h4 className="h4-style mb-2">Floor & Wall Coatings</h4>
                                            <div className="para-txt">
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="service-block">
                                        <span className="icon">
                                            <img src="./assets/images/icons/sketch.png" alt="" />
                                        </span>
                                        <div className="service-meta">
                                            <h4 className="h4-style mb-2">Corrosion Mitigation</h4>
                                            <div className="para-txt">
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content-section lightbg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-xl-4">
                            <div className="sub-heading mb-4">Testimonial</div>
                            <div className="heading mb-5">
                                <span className="weight-light">What Our</span> Client Says
                            </div>
                        </div>
                        <div className="col-lg-7 col-xl-7 offset-xl-1">
                            <TestimonialSlider />
                        </div>
                    </div>
                </div>
            </section>
            <ClientSlider />
        </>
    )
}
export default Home;